// extracted by mini-css-extract-plugin
module.exports = {"background-dark":"background-dark","backgroundDark":"background-dark","background-orange":"background-orange","backgroundOrange":"background-orange"};